// Cross-navigation between custom landing pages, grouped by topic so a bra
// page cross-links other lingerie pages instead of work gloves. The current
// page is removed so visitors only see other brands or product lines.
type CrossLink = { label: string; href: string }

const GLOVE_PAGE_LINKS: CrossLink[] = [
  { label: 'Masker ONEMED', href: '/masker-onemed' },
  { label: 'Sarung Tangan COMET', href: '/sarung-tangan-comet' },
  { label: 'Masker COMET', href: '/masker-comet' },
  { label: 'Sarung Tangan Gekko', href: '/sarung-tangan-gekko' },
  { label: 'Sarung Tangan Matahari', href: '/sarung-tangan-matahari' },
  { label: 'Sarung Tangan Diamond', href: '/sarung-tangan-diamond' },
  { label: 'Sarung Tangan Bulldozer', href: '/sarung-tangan-bulldozer' },
  { label: 'Sarung Tangan Paskibra', href: '/sarung-tangan-paskibra' },
  { label: 'Supplier Sarung Tangan Pabrik', href: '/sarung-tangan-pabrik' },
  { label: 'Sarung Tangan Nitrile', href: '/sarung-tangan-nitrile' },
  { label: 'Sarung Tangan Latex & Nitrile', href: '/sarung-tangan-latex-nitrile' },
]

const LINGERIE_PAGE_LINKS: CrossLink[] = [
  { label: 'CD FEMA', href: '/cd-fema' },
  { label: 'CD Angel', href: '/cd-angel' },
  { label: 'CD Salyna', href: '/cd-salyna' },
  { label: 'CD SayYes', href: '/cd-sayyes' },
  { label: 'Bra Oreo', href: '/bra-oreo' },
  { label: 'Bra Piaoli', href: '/bra-piaoli' },
  { label: 'Bra Tally', href: '/bra-tally' },
  { label: 'Bra Fengyuer', href: '/bra-fengyuer' },
  { label: 'Bra Daililing', href: '/bra-daililing' },
  { label: 'CD Piaoli', href: '/cd-piaoli' },
  { label: 'CD Tally', href: '/cd-tally' },
  { label: 'CD Hello 3105 & 3106', href: '/cd-hello' },
  { label: 'Supplier Bra & Lingerie Surabaya', href: '/supplier-bra-lingerie-surabaya' },
  { label: 'Grosir Underwear Surabaya', href: '/grosir-underwear-surabaya' },
]

const LINGERIE_PATHS = new Set(LINGERIE_PAGE_LINKS.map((link) => link.href))

// Reciprocal link to the canonical brand hub. The hubs already link every
// dedicated LP; this closes the loop so crawlers see hub <-> LP as a pair.
const PAGE_BRAND_HUB: Record<string, CrossLink> = {
  '/masker-onemed': { label: 'Lihat semua produk OneMed', href: '/merek/onemed' },
  '/cd-fema': { label: 'Lihat semua produk FEMA', href: '/merek/fema' },
  '/cd-angel': { label: 'Lihat semua produk Angel', href: '/merek/angel' },
  '/cd-salyna': { label: 'Lihat semua produk Salyna', href: '/merek/salyna' },
  '/cd-sayyes': { label: 'Lihat semua produk SayYes', href: '/merek/sayyes' },
  '/sarung-tangan-comet': { label: 'Lihat semua produk COMET', href: '/merek/comet' },
  '/masker-comet': { label: 'Lihat semua produk COMET', href: '/merek/comet' },
  '/sarung-tangan-gekko': { label: 'Lihat semua produk Gekko Grip', href: '/merek/gekko' },
  '/sarung-tangan-matahari': { label: 'Lihat semua produk Matahari', href: '/merek/matahari' },
  '/sarung-tangan-diamond': { label: 'Lihat semua produk Diamond', href: '/merek/diamond' },
  '/sarung-tangan-bulldozer': { label: 'Lihat semua produk Bulldozer', href: '/merek/bulldozer' },
  '/bra-oreo': { label: 'Lihat semua produk Oreo', href: '/merek/oreo' },
  '/bra-piaoli': { label: 'Lihat semua produk Piaoli', href: '/merek/piaoli' },
  '/cd-piaoli': { label: 'Lihat semua produk Piaoli', href: '/merek/piaoli' },
  '/bra-tally': { label: 'Lihat semua produk Tally', href: '/merek/tally' },
  '/cd-tally': { label: 'Lihat semua produk Tally', href: '/merek/tally' },
  '/bra-fengyuer': { label: 'Lihat semua produk Fengyuer', href: '/merek/fengyuer' },
  '/bra-daililing': { label: 'Lihat semua produk Daililing', href: '/merek/daililing' },
}

export function LpCrossLinks({ currentPath }: { currentPath: string }) {
  const group = LINGERIE_PATHS.has(currentPath) ? LINGERIE_PAGE_LINKS : GLOVE_PAGE_LINKS
  const links = group.filter((link) => link.href !== currentPath)
  const brandHub = PAGE_BRAND_HUB[currentPath]

  return (
    <section className="bg-slate-50 py-12 border-t border-slate-100">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-xl md:text-2xl font-black tracking-tight text-slate-900">Merek lainnya</h2>
        <p className="mt-2 text-base text-slate-500">
          Bandingkan merek dan lini produk lain yang tersedia di Dropify.
        </p>
        <div className="mt-5 flex flex-wrap gap-2.5">
          {brandHub && (
            <a
              href={brandHub.href}
              className="inline-flex items-center rounded-full border border-green-200 bg-green-50 px-4 py-2 text-sm font-semibold text-green-800 transition-colors hover:border-green-300 hover:bg-green-100"
            >
              {brandHub.label}
            </a>
          )}
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href="/merek"
            className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 transition-colors hover:border-blue-300 hover:bg-blue-100"
          >
            Lihat semua merek
          </a>
        </div>
      </div>
    </section>
  )
}
